<template>
    <div
        v-click-outside="handleClickOutside"
        @click="handleClick"
        @mouseenter="handleMouseMove"
        @mousemove="handleMouseMove"
        @mouseleave="hovered = false"
        class="controls-wrapper"
        :class="{
            'cursor-pointer':
                (playerState === PLAYER_STATES.UNINIT ||
                    playerState === PLAYER_STATES.UNSTARTED ||
                    playerState === PLAYER_STATES.PAUSED ||
                    playerState === PLAYER_STATES.ENDED) &&
                playerState !== PLAYER_STATES.ENDED
        }"
    >
        <div
            v-if="
                playerState === PLAYER_STATES.UNINIT ||
                playerState === PLAYER_STATES.UNSTARTED ||
                playerState === PLAYER_STATES.PAUSED ||
                playerState === PLAYER_STATES.ENDED
            "
            class="controls-play"
            :style="{
                backgroundImage: `url('${preview}')`,
                marginTop: playerState === PLAYER_STATES.PAUSED ? '' : 0
            }"
        >
            <button v-if="playerState !== PLAYER_STATES.ENDED" @click="$emit('play')" class="play-button">
                <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                        d="M19.376 12.4158L8.77735 19.4816C8.54759 19.6348 8.23715 19.5727 8.08397 19.3429C8.02922 19.2608 8 19.1643 8 19.0656V4.93408C8 4.65794 8.22386 4.43408 8.5 4.43408C8.59871 4.43408 8.69522 4.4633 8.77735 4.51806L19.376 11.5838C19.6057 11.737 19.6678 12.0474 19.5146 12.2772C19.478 12.3321 19.4309 12.3792 19.376 12.4158Z"
                    ></path>
                </svg>
            </button>
        </div>

        <transition name="fade">
            <div
                v-if="isMobile() && isShowControls && playerState === PLAYER_STATES.PLAYING"
                class="controls-play controls-play_events"
                :style="{
                    marginTop: '-20px'
                }"
            >
                <div
                    :class="{ active: activeTaps.left }"
                    data-tap="left"
                    @touchstart="handleTap"
                    class="left-tap-area"
                ></div>

                <button @click="handleClick(true)" class="play-button">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            d="M15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V7ZM7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V7Z"
                        ></path>
                    </svg>
                </button>

                <div
                    :class="{ active: activeTaps.right }"
                    data-tap="right"
                    @touchstart="handleTap"
                    class="right-tap-area"
                ></div>
            </div>
        </transition>

        <div
            class="controls-loader"
            :class="{ black: playerState === PLAYER_STATES.UNINIT }"
            v-if="
                playerState !== PLAYER_STATES.UNSTARTED &&
                playerState !== PLAYER_STATES.PAUSED &&
                (playerState === PLAYER_STATES.BUFFERING || playerState === PLAYER_STATES.UNINIT)
            "
        >
            <SpinLoader :width="70" />
        </div>

        <div
            @click.stop
            v-if="playerState !== PLAYER_STATES.UNSTARTED && playerState !== PLAYER_STATES.UNINIT"
            class="controls-actions-container"
            :class="{
                mobile: isMobile(),
                'controls-actions-container_hidden':
                    playerState !== PLAYER_STATES.PAUSED && !hovered && !isShowMenu && !isShowControls,
                'controls-actions-container_hidden_forse': playerState !== PLAYER_STATES.PAUSED && isForseHide
            }"
        >
            <div class="controls-actions">
                <div class="video-progress" :class="{ mobile: isMobile() }">
                    <input
                        :style="{ backgroundSize: `${(time / duration) * 100}% 100%` }"
                        :value="time"
                        @input="$emit('update:seek', parseFloat($event.target.value))"
                        min="0"
                        :max="duration"
                        step="0.1"
                        type="range"
                    />
                </div>
                <flex-container align="center" justify="space-between" class="full-width video-actions">
                    <flex-container align="center">
                        <button class="control-action">
                            <svg
                                @click="$emit('pause')"
                                fill="#fff"
                                v-if="playerState !== PLAYER_STATES.PAUSED"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                            >
                                <path d="M6 5H8V19H6V5ZM16 5H18V19H16V5Z"></path>
                            </svg>
                            <svg
                                @click="$emit('play')"
                                v-else
                                fill="#fff"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    d="M19.376 12.4158L8.77735 19.4816C8.54759 19.6348 8.23715 19.5727 8.08397 19.3429C8.02922 19.2608 8 19.1643 8 19.0656V4.93408C8 4.65794 8.22386 4.43408 8.5 4.43408C8.59871 4.43408 8.69522 4.4633 8.77735 4.51806L19.376 11.5838C19.6057 11.737 19.6678 12.0474 19.5146 12.2772C19.478 12.3321 19.4309 12.3792 19.376 12.4158Z"
                                ></path>
                            </svg>
                        </button>

                        <flex-container align="center" class="volume-control" :class="{ 'no-hover': isMobile() }">
                            <button class="control-action" @click="$emit('toggle:mute')">
                                <svg v-if="!muted" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path
                                        d="M6.60282 10.0001L10 7.22056V16.7796L6.60282 14.0001H3V10.0001H6.60282ZM2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z"
                                    ></path>
                                </svg>
                                <svg v-else fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path
                                        d="M10 7.22056L6.60282 10.0001H3V14.0001H6.60282L10 16.7796V7.22056ZM5.88889 16.0001H2C1.44772 16.0001 1 15.5524 1 15.0001V9.00007C1 8.44778 1.44772 8.00007 2 8.00007H5.88889L11.1834 3.66821C11.3971 3.49335 11.7121 3.52485 11.887 3.73857C11.9601 3.8279 12 3.93977 12 4.05519V19.9449C12 20.2211 11.7761 20.4449 11.5 20.4449C11.3846 20.4449 11.2727 20.405 11.1834 20.3319L5.88889 16.0001ZM20.4142 12.0001L23.9497 15.5356L22.5355 16.9498L19 13.4143L15.4645 16.9498L14.0503 15.5356L17.5858 12.0001L14.0503 8.46454L15.4645 7.05032L19 10.5859L22.5355 7.05032L23.9497 8.46454L20.4142 12.0001Z"
                                    ></path>
                                </svg>
                            </button>

                            <div class="range-container mr-10">
                                <input
                                    :style="{ backgroundSize: `${volume * 100}% 100%` }"
                                    v-if="!isMobile()"
                                    :value="volume"
                                    @input="$emit('change:volume', parseFloat($event.target.value))"
                                    min="0"
                                    max="1"
                                    step="0.01"
                                    type="range"
                                />
                            </div>
                        </flex-container>

                        <flex-container class="mb-2 timelines">
                            {{ time | formatTime }}
                            /
                            {{ duration | formatTime }}
                        </flex-container>
                    </flex-container>
                    <flex-container class="ml-20">
                        <div class="relative player-menu-container">
                            <transition name="fade-up">
                                <div v-if="isShowMenu" class="player-menu">
                                    <div :style="getMenuStyle()" class="player-menu-container">
                                        <template v-if="menuState === MENU_STATES.QUALITY">
                                            <div
                                                class="player-menu-item player-menu-item_border"
                                                @click="menuState = MENU_STATES.DEFAULT"
                                            >
                                                <div class="ml-12">← <span class="ml-2">Back</span></div>
                                            </div>
                                            <div
                                                @click="
                                                    $emit('change:quality', level)
                                                    menuState = MENU_STATES.DEFAULT
                                                "
                                                class="player-menu-item"
                                                :class="{ 'player-menu-item_active': level === quality }"
                                                :key="level"
                                                v-for="level in qualityLevels"
                                            >
                                                <div class="ml-15">{{ level }}</div>
                                            </div>
                                        </template>
                                        <template v-if="menuState === MENU_STATES.RATE">
                                            <div
                                                class="player-menu-item player-menu-item_border"
                                                @click="menuState = MENU_STATES.DEFAULT"
                                            >
                                                <div class="ml-12">← <span class="ml-2">Back</span></div>
                                            </div>
                                            <div
                                                @click="
                                                    $emit('change:rate', level)
                                                    menuState = MENU_STATES.DEFAULT
                                                "
                                                class="player-menu-item"
                                                :class="{ 'player-menu-item_active': level === rate }"
                                                :key="level"
                                                v-for="level in rateLevels"
                                            >
                                                <div class="ml-15">{{ level }}x</div>
                                            </div>
                                        </template>
                                        <template v-if="menuState === MENU_STATES.DEFAULT">
                                            <div @click="menuState = MENU_STATES.RATE" class="player-menu-item">
                                                <div class="flex">
                                                    <svg
                                                        class="mr-10"
                                                        fill="#fff"
                                                        width="18"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path
                                                            d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"
                                                        ></path>
                                                    </svg>

                                                    Playback Rate
                                                </div>

                                                {{ rate }}x
                                            </div>
                                            <div
                                                v-if="qualityLevels && qualityLevels.length"
                                                @click="menuState = MENU_STATES.QUALITY"
                                                class="player-menu-item pointer-events-none"
                                            >
                                                <div class="flex">
                                                    <svg
                                                        class="mr-10"
                                                        fill="#fff"
                                                        width="18"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path
                                                            d="M6.17071 18C6.58254 16.8348 7.69378 16 9 16C10.3062 16 11.4175 16.8348 11.8293 18H22V20H11.8293C11.4175 21.1652 10.3062 22 9 22C7.69378 22 6.58254 21.1652 6.17071 20H2V18H6.17071ZM12.1707 11C12.5825 9.83481 13.6938 9 15 9C16.3062 9 17.4175 9.83481 17.8293 11H22V13H17.8293C17.4175 14.1652 16.3062 15 15 15C13.6938 15 12.5825 14.1652 12.1707 13H2V11H12.1707ZM6.17071 4C6.58254 2.83481 7.69378 2 9 2C10.3062 2 11.4175 2.83481 11.8293 4H22V6H11.8293C11.4175 7.16519 10.3062 8 9 8C7.69378 8 6.58254 7.16519 6.17071 6H2V4H6.17071Z"
                                                        ></path>
                                                    </svg>

                                                    Quality
                                                </div>

                                                {{ quality }} (auto)
                                            </div>
                                            <!--                                            <div @click="togglePip" class="player-menu-item">
                                                <div class="flex">
                                                    <svg
                                                        width="18"
                                                        class="mr-10"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                        fill="#fff"
                                                    >
                                                        <path
                                                            d="M21 3C21.5523 3 22 3.44772 22 4V11H20V5H4V19H10V21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM21 13C21.5523 13 22 13.4477 22 14V20C22 20.5523 21.5523 21 21 21H13C12.4477 21 12 20.5523 12 20V14C12 13.4477 12.4477 13 13 13H21ZM20 15H14V19H20V15ZM6.70711 6.29289L8.95689 8.54289L11 6.5V12H5.5L7.54289 9.95689L5.29289 7.70711L6.70711 6.29289Z"
                                                        ></path>
                                                    </svg>

                                                    Picture-in-Picture (PiP)
                                                </div>
                                            </div>-->
                                        </template>
                                    </div>
                                </div>
                            </transition>
                            <button
                                class="control-action"
                                @click="
                                    isShowMenu = !isShowMenu
                                    menuState = MENU_STATES.DEFAULT
                                "
                            >
                                <svg fill="#fff" viewBox="0 0 24 24">
                                    <path
                                        d="M2 11.9998C2 11.1353 2.1097 10.2964 2.31595 9.49631C3.40622 9.55283 4.48848 9.01015 5.0718 7.99982C5.65467 6.99025 5.58406 5.78271 4.99121 4.86701C6.18354 3.69529 7.66832 2.82022 9.32603 2.36133C9.8222 3.33385 10.8333 3.99982 12 3.99982C13.1667 3.99982 14.1778 3.33385 14.674 2.36133C16.3317 2.82022 17.8165 3.69529 19.0088 4.86701C18.4159 5.78271 18.3453 6.99025 18.9282 7.99982C19.5115 9.01015 20.5938 9.55283 21.6841 9.49631C21.8903 10.2964 22 11.1353 22 11.9998C22 12.8643 21.8903 13.7032 21.6841 14.5033C20.5938 14.4468 19.5115 14.9895 18.9282 15.9998C18.3453 17.0094 18.4159 18.2169 19.0088 19.1326C17.8165 20.3043 16.3317 21.1794 14.674 21.6383C14.1778 20.6658 13.1667 19.9998 12 19.9998C10.8333 19.9998 9.8222 20.6658 9.32603 21.6383C7.66832 21.1794 6.18354 20.3043 4.99121 19.1326C5.58406 18.2169 5.65467 17.0094 5.0718 15.9998C4.48848 14.9895 3.40622 14.4468 2.31595 14.5033C2.1097 13.7032 2 12.8643 2 11.9998ZM6.80385 14.9998C7.43395 16.0912 7.61458 17.3459 7.36818 18.5236C7.77597 18.8138 8.21005 19.0652 8.66489 19.2741C9.56176 18.4712 10.7392 17.9998 12 17.9998C13.2608 17.9998 14.4382 18.4712 15.3351 19.2741C15.7899 19.0652 16.224 18.8138 16.6318 18.5236C16.3854 17.3459 16.566 16.0912 17.1962 14.9998C17.8262 13.9085 18.8225 13.1248 19.9655 12.7493C19.9884 12.5015 20 12.2516 20 11.9998C20 11.7481 19.9884 11.4981 19.9655 11.2504C18.8225 10.8749 17.8262 10.0912 17.1962 8.99982C16.566 7.90845 16.3854 6.65378 16.6318 5.47605C16.224 5.18588 15.7899 4.93447 15.3351 4.72552C14.4382 5.52844 13.2608 5.99982 12 5.99982C10.7392 5.99982 9.56176 5.52844 8.66489 4.72552C8.21005 4.93447 7.77597 5.18588 7.36818 5.47605C7.61458 6.65378 7.43395 7.90845 6.80385 8.99982C6.17376 10.0912 5.17754 10.8749 4.03451 11.2504C4.01157 11.4981 4 11.7481 4 11.9998C4 12.2516 4.01157 12.5015 4.03451 12.7493C5.17754 13.1248 6.17376 13.9085 6.80385 14.9998ZM12 14.9998C10.3431 14.9998 9 13.6567 9 11.9998C9 10.343 10.3431 8.99982 12 8.99982C13.6569 8.99982 15 10.343 15 11.9998C15 13.6567 13.6569 14.9998 12 14.9998ZM12 12.9998C12.5523 12.9998 13 12.5521 13 11.9998C13 11.4475 12.5523 10.9998 12 10.9998C11.4477 10.9998 11 11.4475 11 11.9998C11 12.5521 11.4477 12.9998 12 12.9998Z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <button class="control-action" @click.stop.prevent="handleFs">
                            <svg
                                v-if="!fullscreened"
                                fill="#fff"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    d="M8 3V5H4V9H2V3H8ZM2 21V15H4V19H8V21H2ZM22 21H16V19H20V15H22V21ZM22 9H20V5H16V3H22V9Z"
                                ></path>
                            </svg>
                            <svg v-else fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path
                                    d="M18 7H22V9H16V3H18V7ZM8 9H2V7H6V3H8V9ZM18 17V21H16V15H22V17H18ZM8 15V21H6V17H2V15H8Z"
                                ></path>
                            </svg>
                        </button>
                    </flex-container>
                </flex-container>
            </div>
        </div>
    </div>
</template>

<script>
import SpinLoader from "@components/Loaders/SpinLoader.vue"
import FlexContainer from "@components/Containers/FlexContainer.vue"
import ClickOutside from "vue-click-outside"
import { Debouncer } from "@helpers"

const MENU_ITEM_HEIGHT = 38

export const PLAYER_STATES = {
    UNINIT: -2,
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
}

const MENU_STATES = {
    DEFAULT: 1,
    RATE: 2,
    QUALITY: 3
}

export default {
    components: { FlexContainer, SpinLoader },
    props: {
        fullscreened: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        },
        playerState: {
            type: Number,
            default: PLAYER_STATES.UNINIT
        },
        duration: {
            type: Number,
            default: 0
        },
        preview: {
            type: String,
            default: ""
        },
        componentId: {
            type: String,
            default: ""
        },
        qualityLevels: {
            type: Array,
            default: () => []
        },
        rateLevels: {
            type: Array,
            default: () => []
        },
        quality: {
            type: String,
            default: "default"
        },
        rate: {
            type: Number,
            default: 1
        },
        volume: {
            type: Number,
            default: 0
        },
        time: {
            type: Number,
            default: 0
        }
    },
    directives: {
        ClickOutside
    },
    filters: {
        formatTime(val) {
            if (val < 3600) {
                return new Date(val * 1000).toISOString().substring(14, 19)
            }

            return new Date(val * 1000).toISOString().substring(11, 19)
        }
    },
    name: "PlayerControlsWrapper",
    data() {
        return {
            isShowMenu: false,
            isShowControls: false,
            isForseHide: false,
            PLAYER_STATES: PLAYER_STATES,
            MENU_STATES: MENU_STATES,
            menuState: MENU_STATES.DEFAULT,
            hovered: false,
            deboncer: new Debouncer(),
            hideTimeout: false,
            taps: {
                left: false,
                right: false
            },
            activeTaps: {
                left: false,
                right: false
            }
        }
    },
    mounted() {
        /* window.addEventListener("keydown", event => {
            if (window["activePlayer"] && window["activePlayer"] === this.componentId) {
                const code = event.keyCode.toString()
                event.preventDefault()

                if (this.playerState === PLAYER_STATES.PLAYING) {
                    if (code === "37") {
                        this.$emit("backwards")
                    }
                    if (code === "39") {
                        this.$emit("forwards")
                    }
                }
                if (code === "32") {
                    this.$emit(
                        this.playerState === PLAYER_STATES.PAUSED
                            ? "play"
                            : this.playerState === PLAYER_STATES.PLAYING
                            ? "pause"
                            : ""
                    )
                }
            }
        })*/
    },
    methods: {
        handleTap(event) {
            if (!this.isShowControls) {
                return
            }

            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout)
            }

            this.hideTimeout = setTimeout(() => {
                this.isShowControls = false
            }, 3000)

            const target = event.target.dataset.tap

            if (this.taps[target]) {
                setTimeout(() => {
                    this.activeTaps[target] = true

                    setTimeout(() => {
                        this.activeTaps[target] = false
                    }, 1000)
                }, 100)

                if (target === "right") {
                    this.$emit("forwards")
                }
                if (target === "left") {
                    this.$emit("backwards")
                }

                this.taps[target] = false
                return
            }

            this.taps[target] = true

            setTimeout(() => {
                this.taps.left = false
                this.taps.right = false
            }, 1000)
        },
        togglePip() {
            this.$emit("toggle:pip")
        },
        handleFs() {
            this.$emit("toggle:fs")
            this.isShowMenu = false
            this.isShowControls = false

            if (this.isMobile()) {
                this.isForseHide = true
            }
        },
        getMenuStyle() {
            const PADDING = 20
            if (this.menuState === MENU_STATES.DEFAULT) {
                return {
                    width: `300px`,
                    height: `${2 * MENU_ITEM_HEIGHT + PADDING}px`
                }
            }

            if (this.menuState === MENU_STATES.RATE) {
                return {
                    width: `200px`,
                    height: `${(this.rateLevels.length + 1) * MENU_ITEM_HEIGHT + PADDING}px`
                }
            }

            if (this.menuState === MENU_STATES.QUALITY) {
                return {
                    width: `220px`,
                    height: `${(this.qualityLevels.length + 1) * MENU_ITEM_HEIGHT + PADDING}px`
                }
            }
        },
        handleClickOutside() {
            this.isForseHide = false
            this.isShowMenu = false
            this.isShowControls = false
            this.menuState = MENU_STATES.DEFAULT
        },
        handleClick(event = false) {
            this.isForseHide = false

            if (this.isMobile()) {
                if (this.isShowMenu) {
                    this.isShowMenu = false
                    this.menuState = MENU_STATES.DEFAULT
                }
                if (!this.isShowControls) {
                    this.isShowControls = true

                    if (this.hideTimeout) {
                        clearTimeout(this.hideTimeout)
                    }

                    this.hideTimeout = setTimeout(() => {
                        this.isShowControls = false
                    }, 3000)

                    return
                }
            }

            if (this.isShowMenu) {
                this.handleClickOutside()
                return
            }

            if (
                (this.playerState === PLAYER_STATES.UNINIT ||
                    this.playerState === PLAYER_STATES.UNSTARTED ||
                    this.playerState === PLAYER_STATES.PAUSED ||
                    this.playerState === PLAYER_STATES.ENDED) &&
                this.playerState !== PLAYER_STATES.ENDED
            ) {
                this.$emit("play")
                return
            }

            if (!this.isMobile() || event === true) {
                this.$emit(
                    this.playerState === PLAYER_STATES.PAUSED
                        ? "play"
                        : this.playerState === PLAYER_STATES.PLAYING
                        ? "pause"
                        : ""
                )
            }
        },
        handleMouseMove() {
            if (this.isMobile()) {
                return
            }
            this.hovered = true

            if (this.fullscreened) {
                if (this.hideTimeout) {
                    clearTimeout(this.hideTimeout)
                }
                this.hideTimeout = setTimeout(() => {
                    this.hovered = false
                }, 2000)
            }
        },
        isMobile() {
            return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || this.isIOS() || window.innerWidth < 600
        },
        isIOS() {
            return (
                ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
                    navigator.platform
                ) ||
                // iPad on iOS 13 detection
                (navigator.userAgent.includes("Mac") && "ontouchend" in document)
            )
        }
    }
}
</script>

<style scoped lang="sass">
.player-menu
    color: #fff
    position: absolute
    bottom: 65px
    right: -50px
    border-radius: 10px
    overflow: hidden
    @media (max-width: 578px)
        bottom: 10px
    @media (max-width: 578px)
        right: -36px
    .player-menu-container
        overflow: hidden
        transition: .2s
        background: rgba(0, 0, 0, 0.85)
        padding: 10px 0
        @media (max-width: 878px)
            overflow: auto
            max-height: 200px
            scrollbar-color: #B7C4D0 #DDDDDD
            scrollbar-width: thin
            scrollbar-gutter: stable
            &::-webkit-scrollbar
                width: 4px
            &::-webkit-scrollbar-track
                background-color: rgba(0, 0, 0, 0.85)
            &::-webkit-scrollbar-thumb
                background: rgba(161, 161, 161, 0.85)
        @media (max-width: 578px)
            background: rgba(0, 0, 0, 0.95)
            bottom: 10px
        @media (max-width: 420px)
            max-height: 160px
            background: rgba(0, 0, 0, 0.95)
            bottom: 10px
    .player-menu-item
        padding: 0 15px 0 10px
        cursor: pointer
        transition: .2s
        height: 38px
        display: flex
        align-items: center
        justify-content: space-between
        &:hover, &_active
            background: #52525270
        &_border
            border-bottom: 1px solid #262626
.volume-control
    .range-container
        width: 0
        height: 24px
        overflow: hidden
        transition: .2s
        display: flex
        align-items: center
        input[type="range"]
            cursor: pointer
            background: rgba(255, 255, 255, 0.6) linear-gradient(#FFF, #FFF) no-repeat
            &::-webkit-slider-thumb
                background: #FFF
                margin-left: 0 !important
    &:hover:not(&.no-hover)
        @media (min-width: 960px)
            .range-container
                width: 115px

.controls-actions-container
    position: absolute
    bottom: 0
    z-index: 8888
    width: 100%
    transition: .2s
    &_hidden:not(:hover), &_hidden_forse
        bottom: -50px
        &.mobile
            input::-webkit-slider-thumb
                transform: scale(0) !important
        .video-progress
            padding: 0
        .controls-actions::after
            opacity: 0 !important

.video-actions
    padding: 0 10px 0 10px
    @media(max-width: 420px)
        padding: 0
.control-action
    width: 48px
    height: 48px
    display: flex
    align-items: center
    justify-content: center
    svg
        width: 24px
        height: 24px
    @media(max-width: 420px)
        width: 44px
        height: 40px
.controls-actions
    width: 100%
    min-height: 50px
    position: relative
    &::after
        transition: .2s
        opacity: 1
        content: ''
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAACSCAYAAACE56BkAAAAAXNSR0IArs4c6QAAAPVJREFUKFNlyOlHGAAcxvHuY93H1n1fW1v3fbej+zAmI5PIRGYiM5JEEkkiiSSRRPoj83nze9Pz4uPrSUh4tURPEpKDFJWKtCBdZSAzeKOykB3kqFzkBfmqAIVBkSrGW7wLSlQpyoJyVYHKoEpVoyaoVXWoDxpUI5qCZtWC98EH1YqPwSfVhvagQ3WiK+hWPegN+lQ/BoJBNYRhjASjagzjwYSaxOfgi/qKb8GUmsZMMKvmMB8sqEUsYRnf8QMr+IlV/MIa1rGB39jEFv7gL7axg3/4j13sYR8HOMQRjnGCU5zhHBe4xBWucYNb3OEeD3jEE55fAOe7I9q0+rDDAAAAAElFTkSuQmCC")
        z-index: -1
        position: absolute
        bottom: 0
        width: 250%
        height: 146px
        pointer-events: none
        //background: linear-gradient(0deg, #00000073, transparent)
.controls-wrapper
    position: absolute
    top: 0
    right: 0
    left: 0
    bottom: 0
    color: #fff
    z-index: 5
    width: 100%
    height: 100%
.controls-loader, .controls-play
    position: absolute
    top: 0
    right: 0
    left: 0
    bottom: 0
    pointer-events: none
    color: #fff
    z-index: 6666
    display: flex
    align-items: center
    justify-content: center
    border-radius: 10px
    background-repeat: no-repeat
    background-size: cover
    background-position: center
    &_events
        pointer-events: all
        .left-tap-area, .right-tap-area
            position: absolute
            width: calc(50% - 75px / 2)
            left: 0
            height: 100%
            &::after
                opacity: 0
                content: '10'
                position: absolute
                height: 100%
                pointer-events: none
                left: 0
                transition: .2s
                display: flex
                align-items: center
                justify-content: center
                font-size: 40px
                font-family: Inter, sans-serif
                color: rgba(255, 255, 255, 0.82)
                width: calc(100% + 75px / 2)
                border-radius: 0 50% 50% 0
                background-color: rgba(255, 255, 255, 0.32)
            &.active
                &:after
                    opacity: 1
        .right-tap-area
            right: 0
            left: auto
            &::after
                right: 0
                left: auto
                border-radius: 50% 0 0 50%

    &.black
        background-color: #000
.play-button
    width: 75px
    height: 75px
    border-radius: 50%
    background-color: #3965ff
    cursor: pointer
    pointer-events: all
    display: flex
    align-items: center
    justify-content: center
    svg
        width: 50px
input[type="range"]
    -webkit-appearance: none
    width: 100px
    height: 4px
    border-radius: 5px
    background: rgba(255, 255, 255, 0.6) linear-gradient(#3965FF, #3965FF) no-repeat
    transition: height .2s
    &::-webkit-slider-runnable-track, &::-moz-range-track
        -webkit-appearance: none
        box-shadow: none
        border: none
        background: transparent
    &::-webkit-slider-thumb
        -webkit-appearance: none
        height: 14px
        width: 14px
        margin-left: -2px
        border-radius: 50%
        background: #3965FF
        box-shadow: 0 0 2px 0 #555
        transition: .2s
.video-progress
    transition: .2s
    padding: 0 10px
    input
        cursor: pointer
        width: 100% !important
        margin: 0
        &::-webkit-slider-thumb
            transform: scale(0)
    &:hover:not(&.mobile)
        input
            height: 6px
            &::-webkit-slider-thumb
                transform: scale(1)
    &.mobile
        padding: 0 7px
        input
            height: 5px
            &::-webkit-slider-thumb
                transform: scale(1)
.timelines
    @media(max-width: 420px)
        font-size: 14px
</style>
